import { MDBContainer, MDBRow } from 'mdb-react-ui-kit'

import { FlapPicture } from './FlapPicture/FlapPicture'
import { VisionMissionValue } from './VisionMissionValue/VisionMissionValue'
import { WhatWeDo } from './WhatWeDo/WhatWeDo'
import React from 'react'

export function Home() {

    return (
        <>
            <MDBContainer fluid className={'border border-0 border-danger'}>
                <MDBRow>
                    <FlapPicture />
                </MDBRow>
                <MDBRow className='mt-5'>
                    <VisionMissionValue />
                </MDBRow>
                <MDBRow>
                    <WhatWeDo />
                </MDBRow>
            </MDBContainer>
        </>
    )
}